/**
 * Duenner Kaufland-Adapter fuer die geteilte Shell aus
 * @vario-connect/frontend-design: definiert NUR die Marktplatz-Registry
 * dieser App und reicht sie an das geteilte renderShell durch. Optik und
 * Verhalten (Sidebar, Favoriten, DnD, Prefs) leben im Package.
 */
import {
  renderShell as renderSharedShell,
  type Marketplace,
  type ShellContext,
} from '@vario-connect/frontend-design';
import { renderDashboard } from './dashboard.js';

export type { ShellContext };

/* Registry: Marktplatz → Renderer. Heute nur Kaufland. Weitere Marktplaetze
 * werden spaeter als Eintraege ergaenzt; die sichtbare Liste wird dann aus den
 * im Vario Cloud Store gebuchten Marktplaetzen gespeist. */
const MARKETPLACES: Marketplace[] = [
  {
    id: 'kaufland',
    label: 'Kaufland',
    tile: 'K',
    render: (host, ctx) => renderDashboard({ ...ctx, contentEl: host }, { chrome: 'embedded' }),
  },
];

export function renderShell(ctx: ShellContext): Promise<void> {
  return renderSharedShell(ctx, MARKETPLACES);
}
